export default __webpack_public_path__ + "static/media/android-new.6295f22e.png";